<template>
  <b-modal v-model="modalVisible" size="lg" centered hide-footer title="設定篩選條件">
    <template #default>
      <div class="">
        <div class="mb-3">
          <label for="">借用狀態</label>
          <div class="row">
            <div class="col-auto" v-for="s in statusOpts" :key="s.value">
              <b-button size="sm" :variant="filterStatus.includes(s.value)? 'primary': 'secondary'" @click="statusBtnClicked(s.value)"><b-icon icon="check-circle"></b-icon>{{ s.text }}</b-button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="">清洗狀態</label>
          <div class="row">
            <div class="col-auto" v-for="s in washedOpts" :key="s.value">
              <b-button size="sm" :variant="filterWashed.includes(s.value)? 'primary': 'secondary'" @click="washedBtnClicked(s.value)"><b-icon icon="check-circle"></b-icon>{{ s.text }}</b-button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="">填充狀態</label>
          <div class="row">
            <div class="col-auto" v-for="s in filledOpts" :key="s.value">
              <b-button size="sm" :variant="filterFilled.includes(s.value)? 'primary': 'secondary'" @click="filledBtnClicked(s.value)"><b-icon icon="check-circle"></b-icon>{{ s.text }}</b-button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="">尺寸</label>
          <div class="row">
            <div class="col-auto" v-for="s in sizeOpts" :key="s.value">
              <b-button size="sm" :variant="filterSize.includes(s.value)? 'primary': 'secondary'" @click="sizeBtnClicked(s.value)"><b-icon icon="check-circle"></b-icon>{{ s.text }}</b-button>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto">
            <b-button variant="secondary" @click="clear">
              清除
            </b-button>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="save">
              套用
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import moment from 'moment';
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegListFilteringModal',
  data() {
    return {
      filterStatus: [],
      filterWashed: [],
      filterFilled: [],
      filterSize: [],

      statusOpts: [
        {
          text: '在庫',
          value: 0
        },
        {
          text: '出借',
          value: 1
        },
        {
          text: '失蹤',
          value: 2
        },
        {
          text: '退役',
          value: 3
        },
      ],
      washedOpts: [
        {
          text: '未清洗',
          value: false
        },
        {
          text: '已清洗',
          value: true
        },
      ],
      filledOpts: [
        {
          text: '未填充',
          value: false
        },
        {
          text: '已填充',
          value: true
        },
      ],
      sizeOpts: [
        {
          text: '10L',
          value: '10L'
        },
        {
          text: '20L',
          value: '20L'
        },
        {
          text: '30L',
          value: '30L'
        },
      ]
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.filterStatus.splice(0);
        this.filterWashed.splice(0);
        this.filterFilled.splice(0);
        this.filterSize.splice(0);

        for (const s of this.filter.filterStatus) {
          this.filterStatus.push(s);
        }
        for (const s of this.filter.filterWashed) {
          this.filterWashed.push(s);
        }
        for (const s of this.filter.filterFilled) {
          this.filterFilled.push(s);
        }
        for (const s of this.filter.filterSize) {
          this.filterSize.push(s);
        }
      }
    },
  },
  mounted() {
  },
  methods: {
    statusBtnClicked(s) {
      const index = this.filterStatus.indexOf(s);
      if (index === -1) {
        this.filterStatus.push(s);
      } else {
        this.filterStatus.splice(index, 1);
      }
    },
    washedBtnClicked(s) {
      const index = this.filterWashed.indexOf(s);
      if (index === -1) {
        this.filterWashed.push(s);
      } else {
        this.filterWashed.splice(index, 1);
      }
    },
    filledBtnClicked(s) {
      const index = this.filterFilled.indexOf(s);
      if (index === -1) {
        this.filterFilled.push(s);
      } else {
        this.filterFilled.splice(index, 1);
      }
    },
    sizeBtnClicked(s) {
      const index = this.filterSize.indexOf(s);
      if (index === -1) {
        this.filterSize.push(s);
      } else {
        this.filterSize.splice(index, 1);
      }
    },
    dateFormat(timestamp) {
      return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },
    clear() {
      this.filterStatus.splice(0);
      this.filterWashed.splice(0);
      this.filterFilled.splice(0);
      this.filterSize.splice(0);
    },
    save() {
      this.$emit('update', {
        filterStatus: this.filterStatus,
        filterWashed: this.filterWashed,
        filterFilled: this.filterFilled,
        filterSize: this.filterSize,
      });
      this.modalVisible = false;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
</style>
